var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('v-col',{attrs:{"md":"6","cols":"12"}},[_c('v-card',{staticClass:"pa-5",attrs:{"elevation":"3"}},[_c('RouterView',{key:_vm.$route.fullPath})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }